import { http } from "./common";


const getNotificationCategories = async () => {
    return http.get(`/api/v1/notification/notification-categories`);
};

const getNotificationSubscriptions = async () => {
    return http.get(`/api/v1/notification/subscriptions`);
};


const createNotificationSubscription = async (payload) => {
    return http.post(`/api/v1/notification/subscriptions`, payload);
};


const getNotificationChannels = async () => {
    return http.get(`/api/v1/notification/notification-channels`);
};

const getAllNotifications = async (payload) => {
    return http.post(`/api/v1/notifications`, payload);
};

const getUnreadCount = async (payload) => {
    return http.post(`/api/v1/notifications/unread-count`, payload);
};

const markAllRead = async (payload) => {
    return http.post(`/api/v1/notifications/mark-all-read`, payload);
};

const markAllUnread = async (payload) => {
    return http.post(`/api/v1/notifications/mark-all-unread`, payload);
};

const markRead = async (payload) => {
    return http.post(`/api/v1/notifications/mark-read`, payload);
};

const markUnread = async (payload) => {
    return http.post(`/api/v1/notifications/mark-unread`, payload);
};

export {
    getNotificationSubscriptions,
    getNotificationCategories,
    getAllNotifications,
    createNotificationSubscription,
    getNotificationChannels,
    getUnreadCount,
    markAllRead,
    markAllUnread,
    markRead,
    markUnread
};
